<!-- ===================== -->
<!-- SINGLE MAP -->
<!-- ===================== -->

<google-map
  *ngIf="!multiple"
  height="400px"
  width="100%"
  [center]="{ lat: location.lat, lng: location.lng }"
  [zoom]="location.zoom"
  [options]="{
    streetViewControl: false,
    draggable: isDraggable,
    zoomControl: true,
    mapTypeControl: false
  }"
>

  <map-marker
    [position]="{ lat: location.lat, lng: location.lng }"
    [options]="{ draggable: isDraggable }"
    (mapDragend)="markerDragEnd($event)"
  >

    <map-info-window *ngIf="geoAddress">
      <span>{{ geoAddress }}</span>
    </map-info-window>

  </map-marker>

</google-map>


<!-- ===================== -->
<!-- MULTIPLE MAP -->
<!-- ===================== -->

<google-map
  *ngIf="multiple"
  height="400px"
  width="100%"
  [center]="{ lat: location.lat, lng: location.lng }"
  [zoom]="12"
  [options]="{
    streetViewControl: false,
    zoomControl: true,
    mapTypeControl: false
  }"
>

  <map-marker
    *ngFor="let loc of locations; let i = index"
    [position]="{ lat: loc?.lat, lng: loc?.lng }"
    [label]="(i + 1).toString()"
  >

    <map-info-window>
      <div>
        <p>
          <strong>Dirección:</strong>
          {{ loc.address?.split('$%$')?.join(' ') }}
        </p>

        <p>
          <strong>Distrito:</strong>
          {{ loc.district }}
        </p>
      </div>
    </map-info-window>

  </map-marker>

</google-map>